export default __webpack_public_path__ + "static/3-10419f8c5f6fe3131dd1639f6d30abb9.jpg";